import { router } from "@inertiajs/vue3";

// BUG-923: logout is the only place that sets `skip_auto_sso` on the branded org login
// URL, so this render skips the auto-SSO bounce. Strip it from the address bar once
// rendered without dropping other params (notably `next`) or re-navigating to the server,
// which would re-trigger the bounce.
//
// Must use Inertia's client-side router.replace (not history.replaceState). Native
// replaceState races Inertia's InitialVisit, which async-writes page.url (still carrying
// the marker) into history after mount and puts the param back. router.replace updates
// Inertia's in-memory page.url and history through the same queue, so the clean URL sticks.
export function stripSkipAutoSsoMarker(): void {
    const params = new URLSearchParams(globalThis.location.search);
    if (!params.has("skip_auto_sso")) {
        return;
    }

    params.delete("skip_auto_sso");
    const cleanedSearch = params.toString();
    const cleanedUrl = globalThis.location.pathname + (cleanedSearch ? `?${cleanedSearch}` : "");

    router.replace({
        url: cleanedUrl,
        preserveState: true,
        preserveScroll: true,
    });
}
